import { STORE_ASSESSMENT } from './assessmentTypes';

export const storeAssessment = (assessment) => {
  return {
    type: STORE_ASSESSMENT,
    payload: assessment,
  };
};
